/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetDetailLookupResponseDto
 */
export interface AssetDetailLookupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailLookupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailLookupResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetDetailLookupResponseDto interface.
 */
export function instanceOfAssetDetailLookupResponseDto(value: object): value is AssetDetailLookupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetDetailLookupResponseDtoFromJSON(json: any): AssetDetailLookupResponseDto {
    return AssetDetailLookupResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailLookupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailLookupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetDetailLookupResponseDtoToJSON(json: any): AssetDetailLookupResponseDto {
    return AssetDetailLookupResponseDtoToJSONTyped(json, false);
}

export function AssetDetailLookupResponseDtoToJSONTyped(value?: AssetDetailLookupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

